var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var MM_TO_INCHES = 25.4;
var COMMON_DENSITY = 160;
export var handleBaseFontSizePx = function (value, baseFontSizePx) {
    return baseFontSizePx ? value / baseFontSizePx : value;
};
export var convertToUseBaseFontSizePx = function (viewSizes, baseFontSizePx) {
    return Object.entries(viewSizes).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        acc[key] = value / baseFontSizePx;
        return acc;
    }, {});
};
var getTrueWidth = function (widthInPixels, widthInMillimeters) {
    return Math.round((widthInPixels / (widthInPixels / (widthInMillimeters / MM_TO_INCHES))) * COMMON_DENSITY);
};
export var getViewSizeFromDeviceInformation = function (viewSizes, deviceInformation, baseFontSizePx) {
    if (typeof deviceInformation.resolutionWidth === 'number' && deviceInformation.resolutionWidth > 0) {
        var widthInPixels = deviceInformation.resolutionWidth, widthInMillimeters = deviceInformation.physicalScreenWidth;
        var deviceViewSize = widthInPixels;
        if (widthInMillimeters) {
            deviceViewSize = getTrueWidth(widthInPixels, widthInMillimeters);
        }
        return handleBaseFontSizePx(deviceViewSize, baseFontSizePx);
    }
    else if (deviceInformation.tablet === true) {
        return viewSizes.MEDIUM;
    }
    else if (deviceInformation.mobile === true) {
        return viewSizes.SMALL;
    }
    else {
        return viewSizes.LARGE;
    }
};
//# sourceMappingURL=view-size-utils.js.map